import type { Route } from '../lib/router'
import { href } from '../lib/router'
import { APP_VERSION } from '../version'
import {
  IconBuilding, IconFolder, IconLedger, IconScan, IconSparkle,
  IconAudit, IconSettings, IconExternal
} from './Icons'

function isActive(route: Route, target: 'societes' | 'audit'): boolean {
  if (target === 'societes') {
    return route.name === 'societes' || route.name === 'societe' || route.name === 'dossier'
  }
  return route.name === target
}

export function Sidebar({ route }: { route: Route }) {
  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <span className="wordmark">teogest</span>
        <span className="brand-square" aria-hidden="true"></span>
      </div>

      <nav className="sidebar-nav">
        <div className="nav-group">
          <p className="nav-label">Portefeuille</p>
          <a
            className={`nav-item ${isActive(route, 'societes') ? 'nav-item-active' : ''}`}
            href={href('/societes')}
          >
            <IconBuilding size={16} />
            <span>Sociétés</span>
          </a>
          <a className="nav-item nav-item-disabled" aria-disabled="true" tabIndex={-1}>
            <IconFolder size={16} />
            <span>Dossiers annuels</span>
          </a>
          <a className="nav-item nav-item-disabled" aria-disabled="true" tabIndex={-1}>
            <IconLedger size={16} />
            <span>Écritures</span>
          </a>
        </div>

        <div className="nav-group">
          <p className="nav-label">Traitement</p>
          <a className="nav-item nav-item-disabled" aria-disabled="true" tabIndex={-1}>
            <IconScan size={16} />
            <span>Import OCR</span>
          </a>
          <a className="nav-item nav-item-disabled" aria-disabled="true" tabIndex={-1}>
            <IconSparkle size={16} />
            <span>Agent Claude</span>
          </a>
        </div>

        <div className="nav-group">
          <p className="nav-label">Supervision</p>
          <a
            className={`nav-item ${isActive(route, 'audit') ? 'nav-item-active' : ''}`}
            href={href('/audit')}
          >
            <IconAudit size={16} />
            <span>Audit log</span>
          </a>
          <a className="nav-item nav-item-disabled" aria-disabled="true" tabIndex={-1}>
            <IconSettings size={16} />
            <span>Configuration</span>
          </a>
        </div>

        <div className="nav-group">
          <p className="nav-label">Externe</p>
          <a
            className="nav-item nav-item-external"
            href="https://appli.teogest.com/Account/Login#stay"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              <IconExternal size={14} />
              Teogest natif
            </span>
          </a>
        </div>
      </nav>

      <div className="sidebar-account">
        <div className="account-avatar">TG</div>
        <div className="account-info">
          <div className="account-name">Pilotage</div>
          <div className="account-role">v{APP_VERSION}</div>
        </div>
      </div>
    </aside>
  )
}
